import React from 'react';
import PropTypes from 'prop-types';

import { ParagraphStyled } from './Paragraph.styled';

export const paragraphVariant = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  ACCENT: 'accent',
  LIGHT: 'light',
};

export const paragraphSize = {
  XSMALL: 'xsmall',
  SMALL: 'small',
  DEFAULT: 'default',
  MEDIUM: 'medium',
  XMEDIUM: 'xmedium',
  LARGE: 'large',
  XLARGE: 'xlarge',
};

export default function Paragraph(props) {
  const { children, text, display } = props;
  if (!children && text) {
    return (
      <ParagraphStyled dangerouslySetInnerHTML={{ __html: text }} {...props} />
    );
  }
  return (
    <ParagraphStyled display={display} {...props}>
      {children}
    </ParagraphStyled>
  );
}

export { Paragraph };

Paragraph.defaultProps = {
  variant: paragraphVariant.PRIMARY,
  isTruncated: false,
};

Paragraph.propTypes = {
  mt: PropTypes.number,
  mr: PropTypes.number,
  mb: PropTypes.number,
  ml: PropTypes.number,
  display: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  textDecoration: PropTypes.string,
  style: PropTypes.object,
  /**
   * Paragraph text
   */
  text: PropTypes.string,
  /**
   * Defines different appearances for the component
   */
  variant: PropTypes.oneOf(Object.values(paragraphVariant)),
  size: PropTypes.oneOf(Object.values(paragraphSize)),
  /**
   * The same as margin CSS property using a list of predefined sizes (theme.spacing). For example 'default 0' will be the same as '1rem 0'. The theme.spacing keys will be replaced by the correspondent value.
   */
  margin: PropTypes.string,
  /**
   * Showing truncated text
   */
  isTruncated: PropTypes.bool,
};
